import { Navigate } from 'react-router-dom'

/** Submissions now live in the Campaigns hub, under Incoming */
const Submissions = () => <Navigate to="/campaigns?tab=incoming" replace />

export default Submissions
